export enum ListComponent {
    OL = "ol",
    UL = "ul"
}
